<template>
  <div :class="{ 'content content-full': standalone }">
    <div :class="{ 'page-inner': standalone }">
      <div v-if="standalone" class="mb-3">
        <h2>{{ $t('select_release') }}</h2>
        <div v-if="distributions.length" class="mb-2">
          <Select2 v-model="selectedDistribution" :options="distributionOptions"></Select2>
        </div>
        <div v-if="!loadingPage && !distributions.length">
          {{ $t('release_published_needed') }}
        </div>
      </div>
      <div class="banner-container" v-if="currentDistribution">
        <div class="mb-3">
          <div class="h4">
            {{ $t('banner_color') }}
          </div>
          <div class="mt-3 row">
            <div class="col-4 col-md-2">
              <button type="button" class="btn btn-light mb-3" @click="switchColor(0)" :disabled="selectedColor === colors[0]">
                <div :style="`width: 15px; height: 15px; background: ${colors[0]};`"></div>
              </button>
            </div>
            <div class="col-4 col-md-2">
              <button type="button" class="btn btn-light mb-3" @click="switchColor(1)" :disabled="selectedColor === colors[1]">
                <div :style="`width: 15px; height: 15px; background: ${colors[1]};`"></div>
              </button>
            </div>
            <div class="col-4 col-md-2">
              <button type="button" class="btn btn-light mb-3" @click="switchColor(2)" :disabled="selectedColor === colors[2]">
                <div :style="`width: 15px; height: 15px; background: ${colors[2]};`"></div>
              </button>
            </div>
            <div class="col-4 col-md-2">
              <button type="button" class="btn btn-light mb-3" @click="switchColor(3)" :disabled="selectedColor === colors[3]">
                <div :style="`width: 15px; height: 15px; background: ${colors[3]};`"></div>
              </button>
            </div>
            <div class="col-4 col-md-2">
              <button type="button" class="btn btn-light mb-3" @click="switchColor(4)" :disabled="selectedColor === colors[4]">
                <div :style="`width: 15px; height: 15px; background: ${colors[4]};`"></div>
              </button>
            </div>
            <div class="col-4 col-md-2">
              <button type="button" class="btn btn-light mb-3" @click="switchColor(5)" :disabled="selectedColor === colors[5]">
                <div :style="`width: 15px; height: 15px; background: ${colors[5]};`"></div>
              </button>
            </div>
          </div>
        </div>
        <hr>
        <!-- Social Banner Ad -->
        <!-- <div v-if="!user.subscription">
          <ins class="adsbygoogle"
              style="display:block"
              data-ad-client="ca-pub-8326584585992829"
              data-ad-slot="9491304951"
              data-ad-format="auto"
              data-full-width-responsive="true"></ins>
        </div> -->
        <hr>
        <div class="text-center p-3" v-if="loadingPage">
          <i class="fa fa-spinner fa-spin text-muted"></i>
        </div>
        <div class="banners-container" v-if="!loadingPage">
          <a href="#" class="downloadbu" style="display:none;"></a>
          <button @click="exportCanvas(1)" :disabled="loadingBanner" class="btn btn-primary">
            <i v-if="loadingBanner" class="fa fa-spinner fa-spin"></i>
            {{ $t('download_image') }}
          </button>
          <br><br>
          <div class="banner-type-1 mb-4" :style="`width: 750px; height: 290px; background: ${selectedColor}; padding: 40px; position: relative;text-align: initial;`">
            <span style="display:none;">CSS_STYLE_HERE</span>
            <img class="white-logo" src="/static/img/landing/footer/logoblanco.png" alt="Indiefy Logo" height="35" />
            <!-- <img class="black-logo" src="/static/img/landing/distribution/logo-basic.png" alt="Indiefy Logo" height="35" /> -->
            <img :src="(currentDistribution.cover_image_small || currentDistribution.cover_image_medium || currentDistribution.cover_image) + '?v=' + moment().unix()" alt class="cover" @error="onError" ref="bannerImg1" @load="onImgLoad($event, 1)" crossorigin style="width: 210px; height: 210px; margin: 0 auto; float: right; box-shadow: 4px 0px 20px 4px rgba(0,0,0,0.7);"/>
            <div id="text_container_1" class="text-container" style="width: 60%; text-align: center; position: absolute; top: 40px; left: 40px; font-family: 'Poppins'; font-weight: 800; text-transform: uppercase; word-wrap: initial;">
              <span class="title-1" :style=" titleBannerSpanish ? 'font-size: 32px;' : ''" style="display: block; font-size: 35px; color: transparent; -webkit-text-stroke: 1px #fff;">{{ $t('new_release') }}</span>
              <span class="title-2" :style="fontSizeTitle" style="display: block; color: #fff; word-break: break-word;">{{ currentDistribution.title.length > 100 ? currentDistribution.title.substring(0, 97) + '...' : currentDistribution.title}}</span>
              <span class="title-3" style="display: block; font-size: 25px; font-weight: 400; color: #fff;">{{ $t('available_on') }}:</span>
              <span class="stores" style="display: block; margin-top: 24px;" :style="fontSizeStore">
                <!-- <img class="black-banner-store" src="/static/img/banner-generator/tiendas-banner-black.png" alt="Indiefy Logo" /> -->
                <img class="white-banner-store" src="/static/img/banner-generator/tiendas-banner-white.svg" alt="Indiefy Logo" style="display: inline; max-height: 35px;"/>
              </span>
            </div>
          </div>
          <hr />
          <button @click="exportCanvas(2)" :disabled="loadingBanner" class="btn btn-primary mt-3">
            <i v-if="loadingBanner" class="fa fa-spinner fa-spin"></i>
            {{ $t('download_image') }}
          </button>
          <br><br>
          <div class="banner-type-2 mb-4" :style="`width: 750px; height: 750px; background: linear-gradient(0deg, rgba(60,63,68,1) 12%, ${selectedColor} 90%); padding: 50px; position: relative; text-align: center;`">
            <span style="display:none;">CSS_STYLE_HERE</span>
            <img :src="(currentDistribution.cover_image_small || currentDistribution.cover_image_medium || currentDistribution.cover_image) + '?v=' + moment().unix()" alt class="cover" @error="onError" ref="bannerImg2" @load="onImgLoad($event, 2)" style="height: 60%; margin: 0 auto; width: auto; box-shadow: 4px 0px 20px 4px rgba(0,0,0,0.7);" crossorigin/>
            <div id="text_container_2" class="text-container" style="width: 60%; margin: 0 auto; font-family: 'Poppins'; font-weight: 800; text-transform: uppercase; margin-top: 40px;">
              <span class="title-1" style="display: block; font-size: 35px; color: transparent; -webkit-text-stroke: 1px #fff;">{{ $t('new_release') }}</span>
              <span class="title-2" :style="fontSizeTitle2" style="display: block; color: #fff; word-break: break-word;">{{ currentDistribution.title.length > 100 ? currentDistribution.title.substring(0, 97) + '...' : currentDistribution.title}}</span>
              <span class="title-3" style="display: block; font-size: 25px; font-weight: 400; color: #fff;">{{ $t('available_on') }}:</span>
              <span class="stores" style="display: block; margin-top: 24px;">
                <img class="white-banner-store" src="/static/img/banner-generator/tiendas-banner-white.svg" alt="Indiefy Logo" style="display: inline;max-height: 35px;" />
              </span>
            </div>
          </div>
          <hr />
          <button @click="exportCanvas(3)" :disabled="loadingBanner" class="btn btn-primary mt-3">
            <i v-if="loadingBanner" class="fa fa-spinner fa-spin"></i>
            {{ $t('download_image') }}
          </button>
          <br><br>
          <div class="banner-type-3" :style="`width: 420px; background: linear-gradient(0deg, #3c3f44 32%, ${selectedColor} 70%); padding: 50px; position: relative; text-align: center; padding-bottom: 25px;`">
            <span style="display:none;">CSS_STYLE_HERE</span>
            <img :src="(currentDistribution.cover_image_small || currentDistribution.cover_image_medium || currentDistribution.cover_image) + '?v=' + moment().unix()" alt class="cover" @error="onError" ref="bannerImg3" @load="onImgLoad($event, 3)" style="width: 100%; margin: 0 auto; box-shadow: 4px 0px 20px 4px rgba(0,0,0,0.7);" crossorigin/>
            <div id="text_container_3" class="text-container" style="width: 100%; margin: 0 auto; font-family: 'Poppins'; font-weight: 800; text-transform: uppercase; margin-top: 55px;">
              <span class="title-1" style="display: block; font-size: 35px; color: transparent; -webkit-text-stroke: 1px #fff;">{{ $t('new_release') }}</span>
              <span class="title-2" :style="fontSizeTitle3" style="display: block; color: #fff; word-break: break-word;display: block; color: #fff; word-break: break-word;">{{ currentDistribution.title.length >= 100 ? currentDistribution.title.substring(0, 97) + '...' : currentDistribution.title}}</span>
              <span class="title-3" style="display: block; font-size: 25px; font-weight: 400; color: #fff; margin-top: 20px;">{{ $t('available_on') }}:</span>
            </div>
            <span class="stores" style="display: block; margin-top: 0px;">
              <img class="white-banner-store" style="display: inline; max-height: 28px;" src="/static/img/banner-generator/tiendas-banner-white.svg" alt="Indiefy Logo" />
            </span>
            <div class="company" style="color: #fff; text-align: center; font-size: 24px; margin-top: 25px;">Indiefy.net</div>
          </div>
        </div>
      </div>
      <canvas id="banner-canvas" style="display: none;"></canvas>
    </div>
    <UpgradeModal></UpgradeModal>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Distributions from '../services/distributions'
import rasterizeHTML from 'rasterizehtml'
import Select2 from './utils/Select2'
import UpgradeModal from './utils/UpgradeModal'

export default {
  name: 'BannerGenerator',
  props: ['distribution'],
  data: function () {
    return {
      user: {},
      colors: [
        '#2E294E',
        '#7189FF',
        '#CB9CF2',
        '#17BEBB',
        '#E5005D',
        '#F96900'
      ],
      selectedDistribution: '',
      currentDistribution: null,
      distributionOptions: [],
      isMobileApp: navigator.userAgent.indexOf('gonative') >= 0,
      moment: moment,
      defaultImage: '/static/img/img-placeholder.jpg',
      titleBannerSpanish: false,
      distributions: [],
      classBannerMode: '',
      fontSizeTitle: '',
      fontSizeTitle2: '',
      fontSizeTitle3: '',
      fontSizeStore: '',
      loadingBanner: false,
      loadingPage: true,
      standalone: false
    }
  },
  methods: {
    calculateTitleLength: function () {
      // calculate title class for banners
      let titleLength = 20

      if (this.currentDistribution && this.currentDistribution.title && this.currentDistribution.title.length) {
        this.titleLength = this.currentDistribution.title.length
      }

      switch (true) {
        case titleLength >= 0 && titleLength <= 16: // Kill The Zombies
          this.classBannerMode = 'mode-1'
          this.fontSizeTitle = 'font-size: 42px;'
          this.fontSizeTitle2 = 'font-size: 42px;'
          this.fontSizeTitle3 = 'font-size: 36px;'
          break
        case titleLength >= 17 && titleLength <= 27: // Caribean House (Radio Edit)
          this.classBannerMode = 'mode-2'
          this.fontSizeTitle = 'font-size: 34px;'
          this.fontSizeTitle2 = 'font-size: 34px;'
          this.fontSizeTitle3 = 'font-size: 28px;'
          this.fontSizeStore = 'margin-top: 0px;'
          break
        case titleLength >= 28 && titleLength <= 51: // Kika (Originally Performed By 6ix9ine & Tory Lanez)
          this.classBannerMode = 'mode-3'
          this.fontSizeTitle = 'font-size: 24px;'
          this.fontSizeTitle2 = 'font-size: 24px;'
          this.fontSizeTitle3 = 'font-size: 24px;'
          break
        case titleLength >= 52 && titleLength <= 77: // Thank U, Next (Originally Performed By Ariana Grande) [Instrumental Version]
          this.classBannerMode = 'mode-4'
          this.fontSizeTitle = 'font-size: 20px;'
          this.fontSizeTitle2 = 'font-size: 20px;'
          this.fontSizeTitle3 = 'font-size: 20px;'
          this.fontSizeStore = 'margin-top: 0px;'
          break
        case titleLength >= 76 && titleLength <= 97: // The Light Is Coming (Originally Performed By Ariana Grande, Nicki Minaj) [Instrumental Version]
          this.classBannerMode = 'mode-5'
          this.fontSizeTitle = 'font-size: 16px;'
          this.fontSizeTitle2 = 'font-size: 16px;'
          this.fontSizeTitle3 = 'font-size: 16px;'
          break
      }
    },
    switchColor: function (index) {
      if (index > 0 && !this.user.subscription) {
        return this.$eventBus.$emit('showUpgradeModal', '', 'banner_generator')
      }

      this.selectedColor = this.colors[index]
      this.loadingPage = true

      setTimeout(() => {
        this.loadingPage = false
        this.calculateTitleLength()
        this.$forceUpdate()
      }, 500)
    },
    onImgLoad: function (event, mode) {
      let blockSize = 5 // only visit every 5 pixels
      let canvas = document.createElement('canvas')
      let context = canvas.getContext && canvas.getContext('2d')
      let data, width, height, length
      let i = -4
      let rgb = {r: 0, g: 0, b: 0}
      let count = 0
      let hexFinalColor = ''
      height = canvas.height = event.target.naturalHeight || event.target.offsetHeight || event.target.height
      width = canvas.width = event.target.naturalWidth || event.target.offsetWidth || event.target.width
      context.drawImage(event.target, 0, 0)
      try {
        data = context.getImageData(0, 0, width, height)
        length = data.data.length
        while ((i += blockSize * 4) < length) {
          ++count
          rgb.r += data.data[i]
          rgb.g += data.data[i + 1]
          rgb.b += data.data[i + 2]
        }
        // ~~ used to floor values
        rgb.r = ~~(rgb.r / count)
        rgb.g = ~~(rgb.g / count)
        rgb.b = ~~(rgb.b / count)
        let hsp = Math.sqrt(
          0.299 * (rgb.r * rgb.r) +
          0.587 * (rgb.g * rgb.g) +
          0.114 * (rgb.b * rgb.b)
        )
        hexFinalColor = '#' + _.map(rgb, x => {
          const hex = x.toString(16)
          return hex.length === 1 ? '0' + hex : hex
        }).join('')
        if (hsp > 166) { // light
          if (hsp >= 246) {
            hexFinalColor = this.change_brightness(hexFinalColor, 0.5)
          } else {
            hexFinalColor = this.change_brightness(hexFinalColor, 0.9)
          }
        }
      } catch (e) {
        let luma = ''
        do {
          hexFinalColor = '#' + Math.floor(Math.random() * 16777215).toString(16).toLocaleUpperCase()
          let c = hexFinalColor.substring(1)
          let rgb = parseInt(c, 16)
          let r = (rgb >> 16) & 0xff
          let g = (rgb >> 8) & 0xff
          let b = (rgb >> 0) & 0xff
          luma = 0.2126 * r + 0.7152 * g + 0.0722 * b
        } while (luma < 40)
      }

      if (event.path) {
        switch (mode) {
          case 1:
            event.path[1].style.background = hexFinalColor
            break
          case 2:
            event.path[1].style.background = 'linear-gradient(0deg, rgba(60,63,68,1) 12%, ' + hexFinalColor + ' 90%)'
            break
          case 3:
            event.path[1].style.background = 'linear-gradient(0deg, #3c3f44 0%, ' + hexFinalColor + ' 70%)'
            break
        }
      }
    },
    change_brightness: function (hex, rate) {
      if (typeof hex === 'string') {
        hex = hex.replace(/^\s*#|\s*$/g, '')
      } else {
        hex = hex.toString(16)
      }
      if (hex.length === 3) {
        hex = hex.replace(/(.)/g, '$1$1')
      } else {
        hex = ('000000' + hex).slice(-6)
      }
      let r = parseInt(hex.substr(0, 2), 16)
      let g = parseInt(hex.substr(2, 2), 16)
      let b = parseInt(hex.substr(4, 2), 16)
      let h
      let s
      let v
      let hsv = []
      let rgb = []
      hsv = this.rgb2hsv(r, g, b)
      h = hsv[0]
      s = hsv[1]
      v = hsv[2]
      v = parseInt(v * rate)
      rgb = this.hsv2rgb(h, s, v)
      r = rgb[0]
      g = rgb[1]
      b = rgb[2]
      hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
      return '#' + hex.split('.')[0]
    },
    rgb2hsv: function (r, g, b) {
      let v = Math.max(r, g, b)
      let n = v - Math.min(r, g, b)
      let h = n && ((v === r) ? (g - b) / n : ((v === g) ? 2 + (b - r) / n : 4 + (r - g) / n))
      return [60 * (h < 0 ? h + 6 : h), v && n / v, v]
    },
    hsv2rgb: function (h, s, v) {
      let f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0)
      return [f(5), f(3), f(1)]
    },
    onError: function (event) {
      event.target.src = this.defaultImage
    },
    exportCanvas: function (mode) {
      this.loadingBanner = true

      switch (mode) {
        case 1:
          window.$('#banner-canvas').attr('width', '750px').attr('height', '290px')
          break
        case 2:
          window.$('#banner-canvas').attr('width', '750px').attr('height', '750px')
          break
        case 3:
          window.$('#banner-canvas').attr('width', '420px').attr('height', window.$('.banner-type-3').css('height'))
          break
      }

      let html = window.$('.banner-type-' + mode).prop('outerHTML')
      html = html.replaceAll('CSS_STYLE_HERE',
        '<link class="something" rel="stylesheet" href="/static/css/bootstrap.min.css" defer>' +
        '<link class="something" rel="stylesheet" href="/static/css/fonts.min.css" defer>' +
        '<link class="something" href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700&display=swap" rel="stylesheet">'
      )
      let canvas = window.$('#banner-canvas')[0]

      rasterizeHTML.drawHTML(html, canvas).then(() => {
        canvas.toBlob(blob => {
          window.URL = window.URL || window.webkitURL

          if (this.isMobileApp) {
            // window.gonative && window.gonative.share.downloadFile({ url: window.URL.createObjectURL(blob) })
            let file = new File([blob], `image-type-${mode}.jpg`)
            window.gonative && window.gonative.share.downloadFile({ url: window.URL.createObjectURL(file) })
          } else {
            window.$('.downloadbu').attr('href', window.URL.createObjectURL(blob))
            window.$('.downloadbu').attr('download', 'image-type-' + mode + '.jpg')
            window.$('.downloadbu')[0].click()
          }

          this.loadingBanner = false

          window.gtag && window.gtag('event', 'Downloaded', {
            hitType: 'event',
            event_category: 'Banners',
            event_label: 'Banner Downloaded'
          })
        }, 'image/jpeg')
      }, () => {})
    }
  },
  watch: {
    selectedDistribution: function (newVal) {
      if (!newVal) return

      this.currentDistribution = _.find(this.distributions, item => {
        return item._id === newVal
      })

      this.switchColor(0)
    }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale
    this.titleBannerSpanish = this.lang === 'es'
    this.selectedColor = this.colors[0]

    if (!this.distribution) {
      this.standalone = true

      Distributions.getAll({ status: 3 }).then(response => {
        if (!response.data.length) {
          this.loadingPage = false
          return
        }

        this.distributions = response.data
        this.distributionOptions = _.map(response.data, item => {
          return { id: item._id, text: item.artist.name + ' - ' + item.title }
        })

        if (response.data.length) {
          this.currentDistribution = response.data[0]
          this.selectedDistribution = response.data[0]._id
          this.loadingPage = false
        }
      })
    } else {
      this.currentDistribution = this.distribution
      this.loadingPage = false
    }

    this.$forceUpdate()
  },
  mounted: function () {
    this.$forceUpdate()
  },
  components: {
    Select2,
    UpgradeModal
  }
}
</script>

<style>
@media only screen and (max-width: 768px) {
  .banner-type-1,
  .banner-type-2 {
    zoom: 33%;
  }

  .banner-type-3 {
    zoom: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BannerGenerator.vue